import { useModalContext } from 'utils/contexts/modal';
import { AuthedEmailEditModal } from './AuthedEmailEditModal';
import { AuthedEmailDeleteModal } from './AuthedEmailDeleteModal';
import { AuthedEmailCreateModal } from './AuthedEmailCreateModal';
import { AuthedEmailSetDefaultSenderModal } from './AuthedEmailSetDefaultSenderModal';
import type { AllSendersModalState } from '../types';

export const AllSendersModals = () => {
  const { modalState, hideModal } = useModalContext<AllSendersModalState>();
  if (modalState === null) return null;

  const { action } = modalState;

  switch (action) {
    case 'authedEmailEditModal':
      return <AuthedEmailEditModal authedEmail={modalState.authedEmail} onClose={hideModal} />;
    case 'authedEmailDeleteModal':
      return <AuthedEmailDeleteModal authedEmail={modalState.authedEmail} onClose={hideModal} />;
    case 'authedEmailCreateModal':
      return <AuthedEmailCreateModal onClose={hideModal} />;
    case 'authedEmailSetDefaultSenderModal':
      return <AuthedEmailSetDefaultSenderModal onClose={hideModal} />;
    default:
      return null;
  }
};
